import {AxiosError} from 'axios'
import {UseMutationOptions} from 'react-query'

import {API} from '../../../networking/http'

export type UpdateSubscriptionPaymentMethodOptions = {
  data: {
    paymentMethodId: string
    venueId: string
    installmentAmount?: number
  },
  subscriptionBookingId: string
};

export type UpdateSubscriptionPaymentMethodMutationReturnType = undefined

export const updateSubscriptionPaymentMethodEndpoint = (subscriptionBookingId: string) => `memberships/${subscriptionBookingId}/changePaymentMethod`

export type UpdateSubscriptionPaymentMethodMuOp = UseMutationOptions<
  UpdateSubscriptionPaymentMethodMutationReturnType,
  AxiosError,
  UpdateSubscriptionPaymentMethodOptions
>

export const updateSubscriptionPaymentMethod = (params?: UpdateSubscriptionPaymentMethodMuOp): UpdateSubscriptionPaymentMethodMuOp => {
  return ({
    mutationFn: async (options) => {
      const res = await API.put<
        UpdateSubscriptionPaymentMethodOptions,
        UpdateSubscriptionPaymentMethodMutationReturnType
      >(
        updateSubscriptionPaymentMethodEndpoint(options.subscriptionBookingId),
        options.data
      )
      return res.data
    },
    ...params
  })
}

